<template>
  <a
    class="relative m-0 block h-[76px] w-[47px] overflow-hidden p-0 text-center"
    href="https://www.bbb.org/us/ny/brooklyn/profile/online-retailer/back-market-inc-0121-176814/#sealclick"
    rel="nofollow"
    target="_blank"
  >
    <RevIllustration
      alt="Back Market Inc. BBB Business Review"
      class="absolute left-0 top-0 ml-0 w-[200%] !max-w-[200%] hover:ml-[-46px]"
      :height="76"
      :src="toPublicPath('/img/footer/bbb.png')"
      :width="46"
    />
  </a>
</template>

<script setup lang="ts">
import { toPublicPath } from '#imports'

import { RevIllustration } from '@ds/components/Illustration'
</script>
